module.exports = __webpack_public_path__ + "img/certificate3.fa069746.jpg";